<template>
  <div id="app">
    <div style="display:none;">
      <img id="shareImg" src="../static/images/ZTuilogo.png" alt="">
    </div>
    <router-view/>
  </div>
</template>


<script>
export default {
  name: 'App',
  data(){
    return {
      shareImgUrl: '',
    }
  },
  created(){
    let str = window.location.href;
    if(window.location.href.indexOf('http://')!=-1){
      window.location.href = 'https://www.tui-ing.cn'
    }
  },
};
</script>

<style>
    .el-cascader{
      width: 100%;
    }
    .el-input__inner{
      border: none!important;
      padding-left: 0;
      font-size: 20px;
    }
    .el-cascader__label{
      padding-left: 0;
      font-size: 16px;
    }

    .registeredOrlogin .el-form-item{
        border-bottom: 1px solid #eee;
        margin-bottom: 16px;
    }
    .registeredOrlogin .el-form-item__label{
        color: #333;
        font-size: 16px!important;
        display: inline-block;
        text-align: left;
    }
    .registeredOrlogin .el-form-item__content{
        margin-left:0!important;
    }
    .registeredOrlogin .el-input__inner{
        color: #333;
        font-size: 16px!important;
    }
    .registeredOrlogin .el-form-item__content{
        width: calc(100% - 120px);
        display: inline-block!important;
        position: relative;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue